import { NavigateFunction } from 'react-router-dom';
import SaveConfirmationHelper from '@utils/agent-foundation/SaveConfirmationHelper';

type NavigationUtilsParams = {
  setIsSaveConfirmationDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setShowBuilderDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setTestMessages: React.Dispatch<React.SetStateAction<any[]>>;
  clearBoomiAIConversation: () => void;
  clearCustomAgentConversation: () => void;
  abortRequests: () => void;
  setConversationId: React.Dispatch<React.SetStateAction<string>>;
  setConversation: React.Dispatch<React.SetStateAction<any[]>>;
  setShowPreview: React.Dispatch<React.SetStateAction<boolean>>;
  navigate: NavigateFunction;
  setIsReffererTool: React.Dispatch<React.SetStateAction<boolean>>;
  setBuilderDialogTitle: React.Dispatch<React.SetStateAction<string>>;
  t: (key: string) => string;
  setSideBarOpen?: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function createNavigationUtils({
  setIsSaveConfirmationDialogOpen,
  setShowBuilderDialog,
  setTestMessages,
  clearBoomiAIConversation,
  clearCustomAgentConversation,
  abortRequests,
  setConversationId,
  setConversation,
  setShowPreview,
  navigate,
  setIsReffererTool,
  setBuilderDialogTitle,
  t,
  setSideBarOpen,
}: NavigationUtilsParams) {
  const resetState = () => {
    setShowBuilderDialog(false);
    setTestMessages([]);
    clearBoomiAIConversation();
    clearCustomAgentConversation();
    abortRequests();
    setConversationId('');
    setConversation([]);
    SaveConfirmationHelper.clearAllMethods();
    if (setSideBarOpen) setSideBarOpen(false);
  };

  return {
    buildAgent: () => {
      setIsSaveConfirmationDialogOpen(false);
      setShowBuilderDialog(true);
      setTestMessages([]);
      clearBoomiAIConversation();
      clearCustomAgentConversation();
      SaveConfirmationHelper.clearAllMethods();
      setShowPreview(false);
      if (setSideBarOpen) setSideBarOpen(false);
    },
    manageTools: () => {
      resetState();
      navigate('/tools');
    },
    manageSources: () => {
      resetState();
      navigate('/sources');
    },
    manageEnvironments: () => {
      resetState();
      navigate('/environments');
    },
    goToAgentList: () => {
      resetState();
      navigate('/agents');
    },
    goToConsumerExperience: () => {
      resetState();
      navigate('/chat');
    },
    navigateToAgentGarden: () => {
      resetState();
      navigate('/home');
    },
    goToPackagesDeployments: () => {
      resetState();
      navigate('/packages-deployments');
    },
    goToPackages: () => {
      resetState();
      navigate('/packages-deployments?tab=packages');
    },
    goToDeployments: () => {
      resetState();
      navigate('/packages-deployments?tab=deployments');
    },
    goToEnvironments: () => {
      resetState();
      navigate('/environments');
    },
    onClose: () => {
      setIsReffererTool(false);
      setShowBuilderDialog(false);
      setShowPreview(false);
      setBuilderDialogTitle(t('agent_builder_dialog_title_agent_designer'));
      if (setSideBarOpen) setSideBarOpen(false);
    },
    resetState,
  };
}
